import React, { useState, useEffect } from "react";
import { exportTableToPDF } from "../utils/exportPDF";
import { Link } from "react-router-dom";
import axios from "axios";

const PurchaseItemsList = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const user = JSON.parse(localStorage.getItem("user"));

  const kitchenId = user?.kitchen ?? 0;

  useEffect(() => {
    getDataList(kitchenId);
  }, [kitchenId]);

  // ✅ Fetch Data with POST
  const getDataList = async (kitchenId) => {
    try {
      const res = await axios.post(
        "https://api-ims.indevconsultancy.in/purchase_report_item.php",
        { kitchen_id: kitchenId },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.success && res.data.data) {
        const formatted = res.data.data.map((item) => ({
          id: item.id,
          vendor: item.vendor_name.trim(),
          category: item.category_name,
          itemName: item.stock_name,
          quantity: item.quantity,
          unit: item.unit,
          date: item.date,
          total_amount: item.total_amount,
        }));
        setUsers(formatted);
      } else {
        setUsers([]);
      }
    } catch (err) {
      console.error("Error fetching purchase report:", err);
    }
  };

  // ✅ Search filter
  const filteredUsers = users.filter((u) =>
    u.itemName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ✅ Pagination
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  // ✅ Export CSV
  const exportToCSV = () => {
    if (users.length === 0) return;
    const headers = ["S.No.", "Vendor", "Category", "Item", "Quantity", "Unit", "Date", "Total Amount"];
    const rows = users.map((user, index) => [
      index + 1,
      user.vendor,
      user.category,
      user.itemName,
      user.quantity,
      user.unit,
      user.date,
      user.total_amount,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "purchase_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToPDF = () => {
    if (users.length === 0) return alert("No data to export.");
    const headers = ["S.No.", "Vendor", "Category", "Item", "Quantity", "Unit", "Date", "Total Amount"];
    const rows = users.map((u, i) => [i + 1, u.vendor, u.category, u.itemName, u.quantity, u.unit, u.date, u.total_amount]);
    exportTableToPDF({ title: "Purchase Items Report", headers, rows, filename: "purchase_report.pdf", filterInfo: `Total: ${rows.length}` });
  };

  return (
    <div className="container-fluid px-2">
      <div className="content">
        <div className="row align-items-center justify-content-between py-2">
          <div className="col-md-6 col-6">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link to="/mobilehome">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-6 text-end">
            <span className="fs-1">Purchase Report</span>
          </div>
        </div>

        <div className="card">
          <div className="card-header border-info">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setCurrentPage(1);
              }}
            >
              <div className="row g-3">
                <div className="col-lg">
                  <input
                    type="text"
                    placeholder="Search Item..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="col-lg-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Search
                  </button>
                </div>
                <div className="col-lg-1">
                  <button
                    type="button"
                    onClick={() => setSearchTerm("")}
                    className="btn btn-outline-dark w-100"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div></div>
              <div className="text-end">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={exportToCSV}
                >
                  <i className="fas fa-file me-1"></i>Export CSV
                </button>
                <button className="btn btn-danger btn-sm" onClick={exportToPDF}>
                  <i className="fas fa-file-pdf me-1"></i>Export PDF
                </button>
              </div>
            </div>

            <div className="table-responsive scrollbar">
              <table className="table text-center table-bordered table-striped fs--1 mb-0">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>S.No.</th>
                    <th>Vendor</th>
                    <th>Category</th>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Unit</th>
                    <th>Date</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedUsers.length === 0 ? (
                    <tr>
                      <td colSpan="7">No data available</td>
                    </tr>
                  ) : (
                    paginatedUsers.map((user, i) => (
                      <tr key={i}>
                        <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                        <td>{user.vendor}</td>
                        <td>{user.category}</td>
                        <td>{user.itemName}</td>
                        <td>{user.quantity}</td>
                        <td>{user.unit}</td>
                        <td>{user.date}</td>
                        <td>{user.total_amount}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseItemsList;
